import { render, staticRenderFns } from "./CatalogMatching.vue?vue&type=template&id=b25a2316&scoped=true&"
import script from "./CatalogMatching.vue?vue&type=script&lang=js&"
export * from "./CatalogMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25a2316",
  null
  
)

export default component.exports